import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PRODUCT_LICENSE', ['TABLE_PRODUCTS'])
